import { c as createProxyComponent } from "./createProxyComponent-bc556d7c.mjs";
const CLASS_COMPONENT_KEY = "__c";
const patchClassComponent = (component) => {
  component[CLASS_COMPONENT_KEY] = createProxyComponent(component[CLASS_COMPONENT_KEY]);
  return component;
};
const withConfigTransport = (component) => {
  if ("setup" in component) {
    return createProxyComponent(component);
  } else if (CLASS_COMPONENT_KEY in component) {
    return patchClassComponent(component);
  } else {
    component.setup = () => ({
      /* Fake setup function */
    });
    return createProxyComponent(component);
  }
};
const withConfigTransport$1 = withConfigTransport;
export {
  withConfigTransport$1 as w
};
//# sourceMappingURL=withConfigTransport-2705a6a5.mjs.map
